// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"163":"98cec2db","378":"597bf445","383":"1c2be9a7"}[chunkId] + ".js";
};